import { CV } from "@/data/cv";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-black text-[#F4F4F0] border-t-2 border-black">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-16">
        <div className="font-display uppercase text-[10vw] md:text-[7vw] leading-[0.9] tracking-tight">
          Bis bald<span className="text-[#FF3B00]">.</span>
        </div>
        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-8 border-t-2 border-[#F4F4F0]/30 pt-8 font-mono-acc text-[11px] text-[#F4F4F0]/80">
          <div>
            <p className="text-[#F4F4F0]/50 mb-2">// Kontakt</p>
            <a href={`mailto:${CV.email}`} className="hover:text-[#FF3B00] block">{CV.email}</a>
            <a href={`tel:${CV.phone.replace(/\s/g, "")}`} className="hover:text-[#FF3B00] block">{CV.phone}</a>
          </div>
          <div>
            <p className="text-[#F4F4F0]/50 mb-2">// Standort</p>
            <p>{CV.location}</p>
          </div>
          <div className="md:text-right">
            <p className="text-[#F4F4F0]/50 mb-2">// © {year}</p>
            <p>{CV.name} — Alle Rechte vorbehalten</p>
          </div>
        </div>
      </div>
    </footer>
  );
}
